import React from "react";
import Base from "../Base/Base";
import { BiEditAlt } from "react-icons/bi";
import { RiDeleteBin6Fill } from "react-icons/ri";

function ListComponent(props) {
  const listGeneral=props.generalList?props.generalList:[];
  
  const editHandler = (item) => {
    props.onChangeDropShadowHandler("Update");
    props.onEditHandler(item);
  };

  const showArrayData = (data, mainIndex, mainId) => {
    return (
      <>
        {data.map((item, index) => {
          return (
            <tr key={`${item} ${index}`}>
              <td
                className={`${
                  mainIndex === props.headTitle.length - 1 &&
                  "flex items-center "
                }`}
              >
                <span className="w-full block pb-2 border-b-[1px] border-bgdarkgrey">
                  {item}
                </span>
                {mainIndex === props.headTitle.length - 1 && (
                  <span className="flex ml-6">
                    <span
                      onClick={() => editHandler(mainId[index])}
                      className="text-btnbgcolor hover:scale-110 ml-2  cursor-pointer"
                    >
                      <BiEditAlt />
                    </span>
                    {!props.isNotDeleteBtn && (
                      <span
                        onClick={() => props.onDeleteHandler(item)}
                        className="ml-2 text-red  hover:scale-110  cursor-pointer"
                      >
                        <RiDeleteBin6Fill />
                      </span>
                    )}
                  </span>
                )}
              </td>
            </tr>
          );
        })}
      </>
    );
  };
  const showData = (item, index, mainId) => {
    return Array.isArray(item[props.headTitle[index].value]) ? (
      showArrayData(item[props.headTitle[index].value], index, mainId)
    ) : (
      <>
        {typeof item[`${props.headTitle[index].value}`] === "number"
          ? item[`${props.headTitle[index].value}`]
          : item[`${props.headTitle[index].value}`]?.toUpperCase()}
      </>
    );
  };

  return (
    // calling base component to create frame with list of data

    <Base
      setProducType={props.setProducType}
      OptionName={props.OptionName}
      onChangeDropShadowHandler={props.onChangeDropShadowHandler}
      generalList={props.generalList}
      secondCreateBtn={props.secondCreateBtn}
      needAdjust={props.needAdjust}
      setDataForAdjust={props.setDataForAdjust}
    >
      <table className="w-full  py-4 px-1">
        <thead>
          <tr className="text-left rounded-md text-sm text-textgreen ">
            {props.headTitle.map((item) => {
              return (
                <th key={item.title} className="py-4 px-3 whitespace-nowrap ">
                  {item.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="mt-4">
          {listGeneral.length > 0 ? (
            // getting data using headtitle to balance list and data in table
            <>
              {props.generalList.map((item) => {
                return (
                  <tr
                    key={`${item.name} ${item.productId}`}
                    className="text-xs even:bg-bglightgrey odd:bg-bgwhite"
                  >
                    {Object.keys(item).map((secondItem, index) => {
                      return (
                        props.headTitle[index] && (
                          <td
                            key={secondItem}
                            className={`${
                              props.OptionNameList === "Plastic Type" &&
                              index === 1 &&
                              "whitespace-nowrap"
                            }  py-5 font-semibold px-4   ${
                              index === props.headTitle.length - 1 &&
                              props.OptionNameList !== "Product" &&
                              props.OptionNameList !== "Production" &&
                              "flex justify-between"
                            }`}
                          >
                            {showData(item, index, item.id)}
                            {index === props.headTitle.length - 1 &&
                              props.OptionNameList !== "Product" &&
                              props.OptionNameList !== "Production" && (
                                <span className="flex ml-6">
                                  {!props.notShowEditBtn && (
                                    <span
                                      onClick={() => editHandler(item)}
                                      className="text-btnbgcolor hover:scale-110 ml-2  cursor-pointer"
                                    >
                                      <BiEditAlt />
                                    </span>
                                  )}
                                  {!props.isNotDeleteBtn && (
                                    <span
                                      onClick={() =>
                                        props.onDeleteHandler(item)
                                      }
                                      className="ml-2 text-red  hover:scale-110  cursor-pointer"
                                    >
                                      <RiDeleteBin6Fill />
                                    </span>
                                  )}
                                </span>
                              )}
                          </td>
                        )
                      );
                    })}
                  </tr>
                );
              })}
            </>
          ) : (
            <tr>
              <td
                colSpan={props.headTitle.length}
                className="text-center bg-bgwhite text-sm py-2 px-2 md:text-base md:py-3 md:px-4 rounded"
              >
                No {props.OptionName} To Show
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Base>
  );
}

export default ListComponent;
